export default __webpack_public_path__ + "static/media/banner-recuperar-senha.100966b7.png";